import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { Movie } from '../types';

export const useMovies = () => {
    return useQuery({
        queryKey: ['movies'],
        queryFn: async () => {
            const { data: movieRows } = await supabase
                .from('movies')
                .select('*')
                .order('created_at', { ascending: false });
            const moviesList = (movieRows || []) as Movie[];

            // Get unique organizer IDs
            const orgIds = Array.from(new Set(moviesList.map(m => m.organizer_id).filter((x): x is number => typeof x === 'number')));
            
            let orgMap: Record<number, string> = {};
            if (orgIds.length) {
                const { data: orgRows } = await supabase
                    .from('organizers')
                    .select('id, name')
                    .in('id', orgIds);
                for (const o of ((orgRows || []) as { id: number; name: string }[])) orgMap[o.id] = o.name;
            }

            return moviesList.map(m => ({
                ...m,
                organizer: m.organizer ?? (m.organizer_id && orgMap[m.organizer_id] ? orgMap[m.organizer_id] : undefined)
            }));
        },
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
